import React, { useContext, useEffect, useState } from "react";
import { addIcon } from "../assets";
import { read, utils } from "xlsx";
import axios from "axios";
import ContactContext from "../context/ContactContext";

const Button = () => {
  const [fileObject, setFileObject] = useState("");
  const { setUpdated } = useContext(ContactContext);

  const HandleUnion = (arrayObj, number, email) => {
    let newNumber = String(number);
    for (let i = 0; i < arrayObj.length; i++) {
      if (arrayObj[i].phone === newNumber || arrayObj[i].email === email) {
        return true;
      }
    }
    return false;
  };

  const handleImportFunctionality = () => {
    let input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx, .xls, .csv";
    input.onchange = () => {
      let files = Array.from(input.files);
      setFileObject(files);
    };
    input.click();
  };

  function removeDuplicatePhoneNumbers(rows) {
    const uniquePhones = new Set();
    const filteredRows = [];
    for (const row of rows) {
      if (!uniquePhones.has(row.Phone)) {
        uniquePhones.add(row.Phone);
        filteredRows.push(row);
      }
    }
    return filteredRows;
  }

  function removeDuplicateEmail(rows) {
    const uniquePhones = new Set();
    const filteredRows = [];
    for (const row of rows) {
      if (!uniquePhones.has(row.Email)) {
        uniquePhones.add(row.Email);
        filteredRows.push(row);
      }
    }
    return filteredRows;
  }

  useEffect(() => {
    if (fileObject) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          let rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          // sanitizer to remove duplicacies
          rows = removeDuplicatePhoneNumbers(rows);
          rows = removeDuplicateEmail(rows);
          fetch("https://aisensy-server.onrender.com/contacts")
            .then((data) => {
              return data.json();
            })
            .then(({ contacts }) => {
              let unionArray = [];
              rows?.map((item) => {
                if (!HandleUnion(contacts, item.Phone, item.Email)) {
                  unionArray.push(item);
                }
              });
              if (unionArray) {
                unionArray?.map(async (element) => {
                  await axios
                    .post("https://aisensy-server.onrender.com/", {
                      username: element?.Name,
                      email: element?.Email,
                      phone: element?.Phone,
                    })
                    .then((res) => {
                      setUpdated((prevUpdated) => !prevUpdated);
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };
      reader.readAsArrayBuffer(fileObject[0]);
    }
  }, [fileObject]);

  return (
    <div className="importContacts-wrapper" onClick={handleImportFunctionality}>
      <div>
        <img src={addIcon} alt="addIcon-svg" />
      </div>
      <p>Import Contact</p>
    </div>
  );
};

export default Button;
